<template>
<div id="hotels">
    <vue-headful title="Hotels" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <!-- hotels FILTERS -->
        <v-row>
            <!-- Location filter-->
            <v-col cols="12" md="3">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Location</div>
                    <im-place-search class="im-select pa-0 ma-0" placeholder="Any ..." @input="filterLocation($event)" hide-details />
                </v-card>
            </v-col>
            <!--./ location filter-->
            <!-- status filter-->
            <v-col cols="6" md="3">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="status" :items="status_items" item-text="text" item-value="value" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="getItems()"
                        hide-details />
                </v-card>
            </v-col>
            <!--./ status filter-->
            <!-- context filter-->
            <v-col cols="6" md="3">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Context</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="context" :items="contexts" item-text="text" item-value="value" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="getItems()"
                        hide-details />
                </v-card>
            </v-col>
            <!--./ context filter-->
        </v-row>
        <!-- ./ hotels FILTERS -->

        <!-- SEARCH -->
        <v-row class="im-search">
            <v-col cols="12">
                <div class="d-flex">
                    <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                    <im-download v-if="$vuetify.breakpoint.mdAndUp" slot="activator" type="xls" name="hotels.xls" :fields="item_headers_hotels" ref="hotels">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" size="32" v-if="!download_loading_hotels" @click="getDownloadHotels()" style="transform: rotate(180deg);">publish</v-icon>
                            </template>
                            <span>Download csv</span>
                        </v-tooltip>
                        <v-progress-circular v-if="download_loading_hotels" indeterminate color="primary"></v-progress-circular>
                    </im-download>
                    <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" medium @click="dialog_mobile_sort = true">swap_vert</v-icon>
                </div>

                <div class="mx-1 py-2 fields d-flex align-center">
                    <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                    <v-btn class="mx-1" v-for="field in search_fields" :key="field.value" small rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                        <span class="text-capitalize caption">{{field.text}}</span>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat>
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;">
            <!-- <v-data-iterator :items="items" :pagination.sync="pagination" :total-items="total" :rows-per-page-items="rppi"> -->
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template slot="item" slot-scope="props">
                    <im-hotel-item :item="props.item" @click.native="seeHotel(props.item)" />
                </template>

                <template slot="no-data">
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>

            </v-data-iterator>
        </v-card>

    </v-container>

    <!-- dialog reservation -->
    <v-dialog v-model="dialog_hotel" max-width="1140px" max-height="600px" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card class="pb-2">
            <v-card-title class="headline pa-2 ml-2">
                Hotel Details
                <v-spacer />
                <v-btn icon left @click="dialog_hotel=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <im-hotel-modal v-if="hotel_id" :item_id="hotel_id" />
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mx-2" :small="$vuetify.breakpoint.smAndDown" text outlined color="primary" @click="goToConsole()">
                    View in Console
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog reservation -->

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

</div>
</template>

<script>
import Download from '../components/utils/Download.vue';
import IMPlaceSearch from '../components/utils/PlaceSearch.vue';
import IMTableHeader from '../components/utils/IMTableHeader.vue';
import IMSortField from "../components/utils/IMSortField.vue";
import IMHotelItem from '../components/items/HotelCard.vue';
import IMHotelModal from '../components/items/HotelModal.vue';

export default {
    name: `hotels`,

    components: {
        'im-download': Download,
        'im-place-search': IMPlaceSearch,
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-hotel-item': IMHotelItem,
        'im-hotel-modal': IMHotelModal
    },

    data() {
        return {
            hotel_id: null,
            hotel: {},
            place: null,
            dialog_hotel: false,
            dialog_mobile_sort: false,

            // filters
            top_left: null,
            bottom_right: null,
            contract_signed_after: null,
            contract_signed_before: null,
            contract_expiration_after: null,
            contract_expiration_before: null,

            // status filter
            status: null,
            status_items: [
                {
                    text: "Inregistrat",
                    value: "registred"
                }, {
                    text: "Accepted",
                    value: "accepted"
                }, {
                    text: "Publicat",
                    value: "published"
                }, {
                    text: "Suspendat",
                    value: "suspended"
                }, {
                    text: "Refuzat de noi",
                    value: "refused_by_us"
                }, {
                    text: "Refuzat de ei",
                    value: "refused_by_them"
                }
            ],
            // context filter
            context: null,
            contexts: [
                {
                    text: "iMemento",
                    value: "imemento"
                }, {
                    text: "YieldPlanet",
                    value: "yieldplanet"
                }, {
                    text: "PynBooking",
                    value: "pynbooking"
                }
            ],
            // search
            search: null,
            search_ids: null,
            search_fields: [
                {
                    text: 'Hotel Name',
                    value: 'name',
                    selected: true
                }, {
                    text: 'Id',
                    value: 'console_id',
                    selected: true
                }, {
                    text: 'City',
                    value: 'city',
                    selected: true
                }, {
                    text: 'Organization Name',
                    value: 'organization.name',
                    selected: true
                }, {
                    text: 'Email',
                    value: 'contact.email',
                    selected: false
                }, {
                    text: 'Phone',
                    value: 'contact.phone',
                    selected: false
                }
            ],
            search_filter: [],
            search_timeout: 300,

            // table items
            items: [],

            // table attributes
            loading: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            //excel download
            download_items: [],
            download_loading: false,
            im_header: [{
                    text: "Hotel Name",
                    width: "15%",
                    sortable: true,
                    sort_order: 'name',
                    sort_dir: "asc",
                }, {
                    text: "Hotel City",
                    width: "10%",
                    sortable: true,
                    sort_order: 'city',
                    sort_dir: null,
                }, {
                    text: "Organization Name",
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "Contract",
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "Contact",
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                },
            ],
            // download csv
            download_loading_hotels: false,
            item_headers_hotels: {
                'Numele Hotelului': 'name',
                'Judet': 'region',
                'Oras': 'city',
                'Adresa': 'address',
                'Geolocalizare latitudine': 'latitude',
                'Geolocalizare longitudine': 'longitude',
                'Status': 'status',
                'Tipul Unitatii': 'unit_type',
                'Certificat clasificare': 'classification_number',
                'Certificat Status': 'classification_status',
                'Test flag': 'test',
                'Contact Email': 'contact.contact_email',
                'Phone': 'contact.phone',
                'Hotel Email': 'contact.email'
            },

        }
    },

    computed: {

        rppt() {
            return this.$translate.text('app_rppt')
        },
        comp_contract_signed_after: {
            get: function () {
                return this.formatDate(this.contract_signed_after)
            },
            set: function (val) {
                return this.contract_signed_after = val;
            }
        },
        comp_contract_signed_before: {
            get: function () {
                return this.formatDate(this.contract_signed_before);
            },
            set: function (val) {
                return this.contract_signed_before = val;
            }
        },
        comp_contract_expiration_after: {
            get: function () {
                return this.formatDate(this.contract_expiration_after);
            },
            set: function (val) {
                return this.contract_expiration_after = val;
            }
        },
        comp_contract_expiration_before: {
            get: function () {
                return this.formatDate(this.contract_expiration_before);
            },
            set: function (val) {
                return this.contract_expiration_before = val;
            }

        },
    },

    created() {
        this.getItems()
    },

    watch: {

        page: {
            handler() {
                this.getItems()
            }
        },
        size: {
            handler() {
                this.getItems()
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 200)
            }
        },
        place: {
            handler() {
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getPlaces, 200)
            }
        }

    },

    methods: {

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                orders = ['name'];
                dirs = ['asc'];
            }

            //prepare ids search
            let ids = null;
            if(this.search_ids && search) {
                ids = [search];
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/admin/hotels';

            // setup query params
            let params = {
                params: {
                    search: search,
                    ids: ids,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                    // operational fields
                    context: this.context,
                    status: this.status,
                    top_left: this.top_left,
                    bottom_right: this.bottom_right,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        goToConsole() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SSR_CONSOLE + '/hotels/' + this.hotel_console_id + '/edit';
            window.open(endpoint, "_blank");
        },

        filterLocation(location) {
            if(location) {
                this.top_left = location.geometry.viewport.northeast.lat + ',' + location.geometry.viewport.southwest.lng;
                this.bottom_right = location.geometry.viewport.southwest.lat + ',' + location.geometry.viewport.northeast.lng;
            } else {
                this.top_left = null;
                this.bottom_right = null;
            }
            this.getItems();
        },

        getDownloadHotels() {
            this.download_loading_hotels = true;
            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                orders = ['name'];
                dirs = ['asc'];
            }

            //prepare ids search
            let ids = null;
            if(this.search_ids && search) {
                ids = [search];
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/hotels";

            // setup query params
            let params = {
                params: {
                    search: search,
                    ids: ids,
                    fields: fields,
                    size: 1000,
                    page: 1,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                    // operational fields
                    top_left: this.top_left,
                    bottom_right: this.bottom_right,
                    // contract_signed_after: this.contract_signed_after,
                    // contract_signed_before: this.contract_signed_before,
                    // contract_expiration_after: this.contract_expiration_after,
                    // contract_expiration_before: this.contract_expiration_before
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    let items = response.data.data;
                    items.forEach(function (element, index) {
                        if(element.region === null) {
                            items[index].region = '';
                        }
                        if(element.classification_number === null) {
                            items[index].classification_number = '';
                        }
                        if(element.classification_status === null) {
                            items[index].classification_status = '';
                        }
                        if(element.contact_email === null) {
                            items[index].contact_email = '';
                        }
                    })
                    this.$refs.hotels.generate(items);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.download_loading_hotels = false;
                });
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format('D MMM YY');
        },

        seeHotel(item) {
            this.hotel_id = null;
            this.hotel_console_id = null;
            this.hotel_id = item.id;
            this.hotel_console_id = item.console_id;
            this.dialog_hotel = true;
        },

    }

}
</script>
